import { CheckCircle2, Clock, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import type { OnboardingStep } from "@/types/api";

interface VerifyStepProps {
  steps: OnboardingStep[];
  onComplete: () => void;
}

export function VerifyStep({ steps, onComplete }: VerifyStepProps) {
  const completedCount = steps.filter((s) => s.status === "completed").length;
  const totalCount = steps.length;
  const allDone = completedCount === totalCount;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold">Verify Your Setup</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Here&apos;s a summary of your onboarding progress. Detection
          verification may take a few minutes after connecting integrations.
        </p>
      </div>
      <div className="space-y-3">
        {steps.map((step) => (
          <Card key={step.name}>
            <CardContent className="flex items-center gap-3 p-4">
              {step.status === "completed" ? (
                <CheckCircle2 className="h-5 w-5 shrink-0 text-green-500" />
              ) : step.optional ? (
                <Clock className="h-5 w-5 shrink-0 text-muted-foreground" />
              ) : (
                <AlertTriangle className="h-5 w-5 shrink-0 text-amber-500" />
              )}
              <div className="flex-1">
                <p className="text-sm font-medium">{step.name}</p>
                <p className="text-xs text-muted-foreground">
                  {step.status === "completed"
                    ? "Complete"
                    : step.optional
                      ? "Optional — skip if not needed"
                      : "Pending"}
                </p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      <div className="flex items-center gap-3">
        <Button size="lg" onClick={onComplete}>
          {allDone ? "Go to Dashboard" : "Continue to Dashboard"}
        </Button>
        {!allDone && (
          <p className="text-xs text-muted-foreground">
            You can complete remaining steps later from the dashboard.
          </p>
        )}
      </div>
    </div>
  );
}
